export const updateAdvert = (payload?: any) => ({
    type: "@saga/UPDATE_ADVERT",
    payload
});

